import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box, Tabs, Tab, Button, Table, TableHead, TableRow, TableCell, TableBody,
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Switch,
  FormControlLabel, IconButton, Select, MenuItem, Chip, Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const API = process.env.REACT_APP_API_BASE_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
const EMPTY = { name: "", festival: "Diwali", category: "", description: "", image_url: "", mrp: "", price: "", stock: 0, pack_info: "", badge: "", active: true , contents: []};
const STATUSES = ["placed", "confirmed", "out_for_delivery", "delivered", "cancelled"];

const FestivalAdmin = () => {
  const [tab, setTab] = useState(0);
  const [items, setItems] = useState([]);
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
const DRAWER_WIDTH = 280;

  const load = async () => {
    const [i, o] = await Promise.all([
      axios.get(`${API}festival/admin/items`, auth()),
      axios.get(`${API}festival/admin/orders`, auth()),
    ]);
    setItems(i.data.items || []);
    setOrders(o.data.orders || []);
  };
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm(EMPTY); setEditId(null); setOpen(true); };
  const openEdit = (it) => { setForm(it); setEditId(it.id); setOpen(true); };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async () => {
    if (!form.name || !form.price) return alert("Name and price are required");
    editId
      ? await axios.put(`${API}festival/admin/items/${editId}`, form, auth())
      : await axios.post(`${API}festival/admin/items`, form, auth());
    setOpen(false);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this item?")) return;
    await axios.delete(`${API}festival/admin/items/${id}`, auth());
    load();
  };

  const upload = async (e) => {
    const file = e.target.files?.[0];
  if (!file) return;

  const fd = new FormData();
  fd.append("file", file, file.name);

  try {
    const { data } = await axios.post(`${API}/festival/admin/upload`, fd, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        // let the browser set multipart/form-data + boundary
        "Content-Type": undefined,
      },
      transformRequest: (d) => d, // stop axios from touching the FormData
    });
    if (data.success) {
      setForm((f) => ({ ...f, image_url: data.url, image_key: data.key }));
    } else {
      alert(data.message || "Upload failed");
    }
  } catch (err) {
    alert(err.response?.data?.message || "Upload failed");
  } finally {
    e.target.value = ""; // lets you re-pick the same file
  }
};
const uploadContents = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;
  const fd = new FormData();
  fd.append("file", file, file.name);
  fd.append("item_name", form.name || "");
  try {
    const { data } = await axios.post(`${API}/festival/admin/parse-contents`, fd, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        "Content-Type": undefined,
      },
      transformRequest: (d) => d,
    });
    if (data.success) setForm((f) => ({ ...f, contents: data.contents }));
    else alert(data.message || "Could not read the file");
  } catch (err) {
    alert(err.response?.data?.message || "Could not read the file");
  } finally {
    e.target.value = "";
  }
};
  const updateOrder = async (id, patch) => {
    await axios.patch(`${API}festival/admin/orders/${id}`, patch, auth());
    load();
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#F7FAFA",
      ml: { xs: 0, md: `${DRAWER_WIDTH}px` }, mt: { xs: "56px", md: 0 },
      px: { xs: 2, sm: 3, md: 4 }, py: { xs: 3, sm: 4 }, }}>
      <Typography variant="h5" fontWeight={700} mb={2}>🪔 Festival Store</Typography>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label={`Items (${items.length})`} />
        <Tab label={`Orders (${orders.length})`} />
      </Tabs>

      {tab === 0 && (
        <>
          <Button variant="contained" onClick={openNew} sx={{ mb: 2 }}>+ Add Item</Button>
          <Table size="small">
            <TableHead  sx={{bgcolor: "#cfe5e7"}}>
              <TableRow >
                <TableCell>Image</TableCell><TableCell>Name</TableCell><TableCell>Festival</TableCell>
                <TableCell>MRP</TableCell><TableCell>Price</TableCell><TableCell>Stock</TableCell>
                <TableCell>Status</TableCell><TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((it) => (
                <TableRow key={it.id}>
                  <TableCell><img src={it.image_url} alt="" width={48} height={48} style={{ objectFit: "cover", borderRadius: 6 }} /></TableCell>
                  <TableCell>{it.name}<br /><small>{it.pack_info}</small></TableCell>
                  <TableCell>{it.festival}</TableCell>
                  <TableCell>₹{it.mrp}</TableCell>
                  <TableCell>₹{it.price}</TableCell>
                  <TableCell>{it.stock}</TableCell>
                  <TableCell><Chip size="small" label={it.active ? "Active" : "Hidden"} color={it.active ? "success" : "default"} /></TableCell>
                  <TableCell>
                    <IconButton onClick={() => openEdit(it)}><EditIcon fontSize="small" /></IconButton>
                    <IconButton onClick={() => remove(it.id)}><DeleteIcon fontSize="small" /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}

      {tab === 1 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Order</TableCell><TableCell>Customer</TableCell><TableCell>Items</TableCell>
              <TableCell>Total</TableCell><TableCell>Payment</TableCell><TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((o) => (
              <TableRow key={o.id}>
                <TableCell>{o.order_code}<br /><small>{new Date(o.created_at).toLocaleString()}</small></TableCell>
                <TableCell>{o.name}<br />{o.phone}<br /><small>{o.address}</small></TableCell>
                <TableCell>{o.items.map((l) => `${l.name} × ${l.qty}`).join(", ")}</TableCell>
                <TableCell>₹{o.total}</TableCell>
                <TableCell>
                  {o.payment_method.toUpperCase()}
                  <Select size="small" value={o.payment_status} onChange={(e) => updateOrder(o.id, { payment_status: e.target.value })} sx={{ ml: 1 }}>
                    {["pending", "paid", "cod_pending", "cod_collected", "failed"].map((s) => <MenuItem key={s} value={s}>{s}</MenuItem>)}
                  </Select>
                </TableCell>
                <TableCell>
                  <Select size="small" value={o.status} onChange={(e) => updateOrder(o.id, { status: e.target.value })}>
                    {STATUSES.map((s) => <MenuItem key={s} value={s}>{s}</MenuItem>)}
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editId ? "Edit Item" : "Add Festival Item"}</DialogTitle>
        <DialogContent dividers sx={{ display: "grid", gap: 1.5 }}>
          <TextField label="Item name" size="small" value={form.name} onChange={set("name")} />
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <TextField label="Festival (Diwali, Holi…)" size="small" fullWidth value={form.festival} onChange={set("festival")} />
            <TextField label="Category" size="small" fullWidth value={form.category} onChange={set("category")} />
          </Box>
          <TextField label="Pack info (e.g. Box of 25 pcs)" size="small" value={form.pack_info} onChange={set("pack_info")} />
          <TextField label="Description" size="small" multiline rows={2} value={form.description} onChange={set("description")} />
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <TextField label="MRP ₹" type="number" size="small" fullWidth value={form.mrp} onChange={set("mrp")} />
            <TextField label="Selling price ₹" type="number" size="small" fullWidth value={form.price} onChange={set("price")} />
            <TextField label="Stock" type="number" size="small" fullWidth value={form.stock} onChange={set("stock")} />
          </Box>
          <TextField label="Badge (optional, e.g. Bestseller)" size="small" value={form.badge} onChange={set("badge")} />
          <Box>
            <TextField label="add image url" size="small" value={form.image_url} onChange={set("image_url")} />
          </Box>
          <Box sx={{ border: "1px dashed", borderColor: "divider", borderRadius: 2, p: 1.5 }}>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
    <Button component="label" variant="outlined" size="small">
      Upload contents (Excel)
      <input hidden type="file" accept=".xlsx" onChange={uploadContents} />
    </Button>
    {form.contents?.length > 0 ? (
      <>
        <Chip size="small" color="success" label={`${form.contents.length} products loaded`} />
        <Button size="small" color="error" onClick={() => setForm({ ...form, contents: [] })}>Remove</Button>
      </>
    ) : (
      <Typography variant="caption" color="text.secondary">
        Columns: No., Product Name, Size, Package, Pieces per Package
      </Typography>
    )}
  </Box>

  {form.contents?.length > 0 && (
    <Box sx={{ maxHeight: 180, overflowY: "auto", mt: 1.5 }}>
      <Table size="small">
        <TableBody>
          {form.contents.map((c) => (
            <TableRow key={c.no}>
              <TableCell>{c.no}</TableCell>
              <TableCell>{c.name}</TableCell>
              <TableCell>{c.size}</TableCell>
              <TableCell>{[c.package, c.pieces && `${c.pieces} pcs`].filter(Boolean).join(" · ")}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )}
</Box>
          <FormControlLabel control={<Switch checked={!!form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} />} label="Visible to customers" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={save}>Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FestivalAdmin;